import React from 'react';

import classNames from 'classnames';

import classes from './styles.module.scss';

export default function Checkbox({
  backgroundColor,
  isSelected,
  onChange,
  label,
  readonly,
}) {
  return (
    <div
      onClick={readonly ? () => {} : onChange}
      className={classNames(classes.Checkbox, {
        [classes.selected]: isSelected,
        [classes.readonly]: readonly,
      })}
      style={{ columnGap: label ? '10px' : '0' }}
    >
      <div className={classes.buttonWrapper}>
        <div style={{ backgroundColor }} className={classes.button} />
      </div>
      <div className={classes.label}>{label}</div>
    </div>
  );
}
